
/* global BrowserPrint */

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from '@mui/material';
import ListSaida from '../modals/listsaida'; // Componente da modal
import PrintIcon from '@mui/icons-material/Print';
import { finishSaida } from '../../services/api'; // Função para enviar os dados para o backend
import ConfirmModal from '../modals/confirmx';      // Modal de confirmação
import FeedbackModal from '../modals/FeedbackModal'; // Modal de feedback (loading, success, error)


const SaidaPorCliente = ({ client, onBack }) => {
  // Cada palete terá: id, codes (dados da ficha de obras) e isModalOpen (se sua modal está aberta)
  const [pallets, setPallets] = useState([]);
   // Estados para as novas modais de confirmação e feedback
   const [confirmVisible, setConfirmVisible] = useState(false);
   const [feedbackVisible, setFeedbackVisible] = useState(false);
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [submissionComplete, setSubmissionComplete] = useState(false);
   const [error, setError] = useState('');

  // Adiciona um novo palete à lista (inicialmente sem códigos e com modal fechada)
  const handleAddPallet = () => {
    setPallets([
      ...pallets, 
      { id: pallets.length + 1, codes: [], isModalOpen: false }
    ]);
  };

  // Abre a modal do palete específico
  const handleOpenModal = (palletId) => {
    setPallets(prevPallets =>
      prevPallets.map(p =>
        p.id === palletId ? { ...p, isModalOpen: true } : p
      )
    );
  };

  // Fecha a modal do palete específico
  const handleCloseModal = (palletId) => {
    setPallets(prevPallets =>
      prevPallets.map(p =>
        p.id === palletId ? { ...p, isModalOpen: false } : p
      )
    );
  };

  // Recebe os códigos salvos na modal e atualiza o palete correspondente
  const handleSaveCodes = (palletId, codes) => {
    setPallets(prevPallets =>
      prevPallets.map(p =>
        p.id === palletId ? { ...p, codes, isModalOpen: false } : p
      )
    );
  };

  const handlePrint = () => {
    let zpl = "";
    
    // Itera sobre cada palete
    for (const pallet of pallets) {
      const numPages = Math.ceil(pallet.codes.length / 6);
      
      // Loop para cada página do palete
      for (let page = 0; page < numPages; page++) {
        zpl += "^XA\n";
        zpl += "^PW800\n";
        zpl += "^LL1260\n";
        
        zpl += "^FO20,20^GB760,1240,2^FS\n";
        zpl += `^FO40,40^A0N,40,40^FDCliente: ${client.name}^FS\n`;
        zpl += `^FO40,100^A0N,35,35^FDPalete ${pallet.id}^FS\n`;
        
        zpl += `^FO20,140^GB760,990,2^FS\n`;
        zpl += `^FO20,170^GB760,0,2^FS\n`;
        zpl += `^FO520,140^GB0,990,2^FS\n`;
        zpl += `^FO650,140^GB0,990,2^FS\n`;
        
        zpl += `^FO40,145^A0N,30,30^FDref^FS\n`;
        zpl += `^FO545,145^A0N,30,30^FDCaixas^FS\n`;
        zpl += `^FO715,145^A0N,30,30^FDqtd^FS\n`;
        
        const startIndex = page * 6;
        const endIndex = startIndex + 6;
        const entries = pallet.codes.slice(startIndex, endIndex);
        
        // Itera sobre os itens usando um loop for tradicional
        for (let i = 0; i < entries.length; i++) {
          const item = entries[i];
          const groupY = 170 + (i * 160);
          const refText = item.reference || 'N/A';
          const maxChars = 30;
          const refLine1 = refText.substring(0, maxChars);
          const refLine2 = refText.substring(maxChars);
          
          zpl += `^FO30,${groupY + 10}^A0N,25,25^FDRef: ${refLine1}^FS\n`;
          zpl += `^FO30,${groupY + 40}^A0N,25,25^FD${refLine2}^FS\n`;
          
          const midY = groupY + 80;
          zpl += `^FO585,${midY}^A0N,30,30^FD${item.boxes || 'N/A'}^FS\n`;
          const totalQuantity =
            item.quantityPerBox && item.boxes ? item.quantityPerBox * item.boxes : 'N/A';
          zpl += `^FO715,${midY}^A0N,30,30^FD${totalQuantity}^FS\n`;
        }
        
        zpl += "^XZ\n";
      }
    }
    
    // Envia o ZPL para a impressora
    enviarZPLParaImpressora(zpl);
  };
  
  function enviarZPLParaImpressora(zplCode) {
    // Certifique-se que o objeto BrowserPrint esteja disponível globalmente
    BrowserPrint.getDefaultDevice("printer", function(printer) {
        if (printer) {
            printer.send(zplCode, function() {
                console.log("Etiqueta enviada para a impressora com sucesso.");
            }, function(error) {
                console.error("Erro ao enviar para a impressora:", error);
            });
        } else {
            console.error("Impressora não encontrada.");
        }
    });
  }

  // Em vez de finalizar diretamente, exibe a modal de confirmação
  const handleFinish = () => {
    setConfirmVisible(true);
  };

  const handleConfirmFinish = async () => {
    setConfirmVisible(false);
    setFeedbackVisible(true);
    setIsSubmitting(true);
    setError('');
  
    const payload = {
      client: client.name,
      pallets: pallets.map(p => ({
        id: p.id,
        codes: p.codes // Cada item deve conter, por exemplo, reference, boxes e quantityPerBox
      }))
    };
  
    try {
      const response = await finishSaida(payload);
      console.log("Resposta da API:", response.data);
      setIsSubmitting(false);
      setSubmissionComplete(true);
  
      // Após 2 segundos, volta para o componente pai (lista de clientes)
      setTimeout(() => {
        onBack();
      }, 2000);
    } catch (err) {
      console.error("Erro ao finalizar saída:", err);
      setIsSubmitting(false);
      setError(err.message || "Erro desconhecido.");
    }
  };

  // Função para fechar a modal de feedback e reiniciar os estados relacionados
  const handleFeedbackClose = () => {
    setFeedbackVisible(false);
    setSubmissionComplete(false);
    setError('');
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* Cabeçalho com botão Voltar, Terminar e ícone de impressora */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Button variant="outlined" onClick={onBack}>
          Voltar
        </Button>
        <Box>
          <Button 
            variant="outlined" 
            onClick={handlePrint} 
            sx={{ ml: 1 }} 
            startIcon={<PrintIcon />}
          >
            Imprimir Etiqueta De Saída
          </Button>
          <Button variant="contained" onClick={handleFinish} sx={{ ml: 1 }}>
            Terminar
          </Button>
        </Box>
      </Box>
      <Typography variant="h6" gutterBottom>
        Saída por Cliente: {client.name}
      </Typography>
      {/* Botão para adicionar novo palete */}
      <Box sx={{ mb: 2 }}>
        <Button variant="outlined" onClick={handleAddPallet}>
          Adicionar Palete
        </Button>
      </Box>
      {/* Tabela de Paletes */}
      {pallets.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Palete</TableCell>
              <TableCell>Dados</TableCell>
              <TableCell>Ação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pallets.map((pallet) => (
              <TableRow key={pallet.id}>
                <TableCell>Palete {pallet.id}</TableCell>
                <TableCell>
                  {pallet.codes && pallet.codes.length > 0 ? (
                    <>
                      {pallet.codes.map((item, index) => (
                        <React.Fragment key={index}>
                          {`Ref: ${item.reference || 'N/A'} - Caixas: ${item.boxes || 'N/A'} - Qtd/caixa: ${item.quantityPerBox || 'N/A'}`}
                          {index < pallet.codes.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </>
                  ) : 'Nenhum'}
                </TableCell>
                <TableCell>
                  <Button 
                    variant="outlined" 
                    onClick={() => handleOpenModal(pallet.id)}
                  >
                    Ficha de Obras
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {/* Renderiza a modal para cada palete que estiver com isModalOpen true */}
      {pallets.map(pallet => (
        pallet.isModalOpen && (
          <ListSaida
            key={pallet.id}
            open={pallet.isModalOpen}
            onClose={() => handleCloseModal(pallet.id)}
            onSave={(codes) => handleSaveCodes(pallet.id, codes)}
            initialData={pallet.codes}
          />
        )
      ))}
      {/* Modal de confirmação */}
      {confirmVisible && (
        <ConfirmModal
          visible={confirmVisible}
          message="Tem certeza que deseja finalizar a saída?"
          onConfirm={handleConfirmFinish}
          onCancel={() => setConfirmVisible(false)}
        />
      )}
      {/* Modal de feedback */}
      {feedbackVisible && (
        <FeedbackModal
          open={feedbackVisible}
          isSubmitting={isSubmitting}
          submissionComplete={submissionComplete}
          error={error}
          onClose={handleFeedbackClose}
        />
      )}
    </Box>
  );
};

export default SaidaPorCliente;
